import vamsiImage from '../assets/vamsi.jpg';

export const events = [
  {
    id: 'retro-bar-dj-night-05-29',
    date: '2026-05-29',
    formattedDate: 'May 29, 2026',
    formattedDateLong: 'May 29, 2026',
    day: 'Friday',
    title: 'DJ Vamsi - Project Desi',
    subtitle: 'PROJECT DESI',
    djName: 'DJ VAMSI',
    djDescription: 'Project Desi',
    image: vamsiImage,
    time: '10:00 PM',
    specialOffer: null,
    description: 'Experience Project Desi with DJ VAMSI at The Retro Street. Get ready for an unforgettable Friday night of music, energy, and pure entertainment.',
    bookingUrl: 'https://retro-bar-tx.maghil.com/restaurant/retro-bar-tx/menu/Pickup/event/retro-bar-dj-night-05-29'
  }
];
